export default __webpack_public_path__ + "1805d779728193026cadc3b4fdd2a88a.riv";